module.exports = __webpack_public_path__ + "static/media/16UNODC39.f38ec393.jpg";